$(document).on('click','.drawerOpenerWrap',function(){
  $(document).find('.my-outfit-home').addClass("qwick-add-active");
  $(document).find('.drawerOpenerWrap').addClass('active');
  var datahandle =$(this).attr('value');
  var Slef = $(this);
                                                                
  jQuery.getJSON(window.Shopify.routes.root + 'products/'+datahandle+'.js', function(product) {

    var itemDrawerSizeSwatchesHtml = '';
    var handle = product.handle;
    for (var k in product.options) {
      var option = product['options'][k];
      var downcasedOption = option.name.toLowerCase();
      var SizeTypes = ['size', 'size', 'størrelse'];
      if (SizeTypes.indexOf(downcasedOption) > -1) {
        var option_index = k;
        var values = [];
        itemDrawerSizeSwatchesHtml += '<div class="size-quick-product-size"><label>select size</label><div class="drawerSizeVariant"><ul class="Sizelist">';
        for (var i in product.variants) {
          var variant = product['variants'][i];
          var value = variant['options'][option_index];
          if (values.indexOf(value) == -1) {
            var values = values.join(',');
            values += ',' + value;
            values = values.split(',');
            var sizeOptionlong = value.toLowerCase();
            var drawerPlusSvg ='<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="1bd8a4fa-a45b-4c86-b953-c889639091f9"><title id="1bd8a4fa-a45b-4c86-b953-c889639091f9">Add</title><path d="m13.2 6h-2.4v4.8h-4.8v2.4h4.8v4.8h2.4v-4.8h4.8v-2.4h-4.8zm-1.2-6c-6.624 0-12 5.376-12 12s5.376 12 12 12 12-5.376 12-12-5.376-12-12-12zm0 21.6c-5.292 0-9.6-4.308-9.6-9.6s4.308-9.6 9.6-9.6 9.6 4.308 9.6 9.6-4.308 9.6-9.6 9.6z"></path></svg>'
            if(handle == 'structured-wide-leg-sweatpants-white'){
              if(sizeOptionlong == 'extra large'){
              var SizeOptionShort = 'XL/Regular';
              var sizeLong = 'XL/Long';
              }else if(sizeOptionlong == 'extra extra large'){
                SizeOptionShort = 'XXL/Regular';
                sizeLong = 'XXL/Long';
              }else if(sizeOptionlong == 'extra small'){
                SizeOptionShort = 'XS/Regular';
                sizeLong = 'XS/Long';
              } else if(sizeOptionlong == 'extra small/small'){
                SizeOptionShort = 'XS/S'
              } else if(sizeOptionlong == 'large'){
                SizeOptionShort = 'L/Regular';
                sizeLong = 'L/Long';
              } else if(sizeOptionlong == 'medium'){
                SizeOptionShort = 'M/Regular';
                sizeLong = 'M/Long';
              }else if(sizeOptionlong == 'small/medium'){
                SizeOptionShort = 'S/M'
              }else if(sizeOptionlong == 'x large'){
                SizeOptionShort = 'XL/Regular';
                sizeLong = 'XL/Long';
              }else if(sizeOptionlong == 'small'){
                SizeOptionShort = 'S/Regular';
                sizeLong = 'S/Long';
              }else if(sizeOptionlong == 'medium/large'){
                SizeOptionShort = 'M/L'
              }else{
                SizeOptionShort = sizeOptionlong
              }
            }else{
             if(sizeOptionlong == 'extra large'){
              var SizeOptionShort = 'XL';
              }else if(sizeOptionlong == 'extra extra large'){
                SizeOptionShort = 'XXL';
              }else if(sizeOptionlong == 'extra small'){
                SizeOptionShort = 'XS';
              } else if(sizeOptionlong == 'extra small/small'){
                SizeOptionShort = 'XS/S'
              } else if(sizeOptionlong == 'large'){
                SizeOptionShort = 'L';
              } else if(sizeOptionlong == 'medium'){
                SizeOptionShort = 'M';
              }else if(sizeOptionlong == 'small/medium'){
                SizeOptionShort = 'S/M'
              }else if(sizeOptionlong == 'x large'){
                SizeOptionShort = 'XL';
              }else if(sizeOptionlong == 'small'){
                SizeOptionShort = 'S';
              }else if(sizeOptionlong == 'medium/large'){
                SizeOptionShort = 'M/L'
              }else{
                SizeOptionShort = sizeOptionlong
              } 
            }
            
            var spinSvg ='<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto;  display: block; shape-rendering: auto;" width="20" height="20" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="#e15b64" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"/></circle><!-- [ldio] generated by https://loading.io/ --></svg>'

            var checkSvg ='<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 25" fill="none"><path d="M20 6.5L9 17.5L4 12.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'


            if(variant.available) {
              itemDrawerSizeSwatchesHtml += '<li class="grid-size-values grid-collectswatch " data-id="'+ variant.id +'" title="'+ variant.inventory_quantity + ' In Stock" class="instock coll-varaint-color"><div class="drawer-size-Name"><span class="grid-size-name">'+SizeOptionShort+'</span></div><div class="addVariant"><span class="addToBagT">Add to bag</span><span class="addToBagS">'+drawerPlusSvg+' </span><span class="drawerSpinSvg spin-svg">'+spinSvg+'</span><span class="drawerCheckSvg check-svg">'+checkSvg+'</span></div></li>';
             if(handle == 'structured-wide-leg-sweatpants-white'){
                itemDrawerSizeSwatchesHtml += '<li class="grid-size-values grid-collectswatch " data-id="'+ variant.id +'" title="'+ variant.inventory_quantity + ' In Stock" class="instock coll-varaint-color"><div class="drawer-size-Name"><span class="grid-size-name">'+sizeLong+'</span></div><div class="addVariant"><span class="addToBagT">Add to bag</span><span class="addToBagS">'+drawerPlusSvg+' </span><span class="drawerSpinSvg spin-svg">'+spinSvg+'</span><span class="drawerCheckSvg check-svg">'+checkSvg+'</span></div></li>';
             }
            } else {
              itemDrawerSizeSwatchesHtml += '<li class="grid-option-soldout" id="'+ variant.id +'" title="Out of Stock"  class="outstock coll-varaint-color" >'+ SizeOptionShort +'</li>';
            }
          }
        }
        itemDrawerSizeSwatchesHtml += '</ul></div></div>';
      }
    }
    var featuredImage = '<div class="drawerProductImage"> <img src="'+product.featured_image+'" width="150"  > </div>'
    var closeButton = '<div class="drawercloseWrap"><span class="drawerclose"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 37 40"><path d="M21.3 23l11-11c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0l-11 11-11-11c-.8-.8-2-.8-2.8 0-.8.8-.8 2 0 2.8l11 11-11 11c-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6l11-11 11 11c.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2 0-2.8l-11-11z"/></svg></span></div>'
    var productTitle = '<div class="drawerProductTitle"><span class="Dproduct-title">'+product.title+'</span></div>'    
    if(Slef.parents('.grid__item').hasClass( "boostAppGrid" )){
      if(Slef.parents('.grid-view-item').find('[data-price]').hasClass('price--on-sale')){
      	var dataPrice = Slef.parents('.grid-view-item').find('[data-price]').html();
      }else{
      	var dataPrice = Slef.parents('.grid-view-item').find('[data-price] .price__regular').html();
      }  
      dataPrice = '<div class="drawerPrice">'+dataPrice+'</div>'
    }else{
     // var dataPrice = Slef.parents('.grid-view-item').find('.limoniapps-discountninja-productprice').html();
      var dataPrice = Slef.parents('product-card').find('.money').html();
      
      if(dataPrice == undefined){
        dataPrice = Slef.parents('.grid-view-item').find('.sa-price').html();
      }
      dataPrice = '<div class="drawerPrice">'+dataPrice+'</div>'
    }
    var clsQuick = '<div class="cls-main"><span class="cls-quick">x</span></div>';
    var productPiceTitle = '<div class="productPriceTitle">'+productTitle+dataPrice+'</div>';
    var productDetail = '<div class="drawerProductDetail">'+featuredImage+productPiceTitle+closeButton+'</div>';
    $(document).find('.size-quick-drawer-wrap').addClass('active');
    $(document).find('.size-quick-drawer').html(clsQuick+productDetail+itemDrawerSizeSwatchesHtml);

  }); 
  setTimeout(function(){
  	 $('.size-quick-drawer').css('transform','translatey(0px)');
  },500)
})

$(document).on('click','.cls-main',function(){
  $(document).find('.drawercloseWrap').trigger('click');
});

$(document).on('click','.drawercloseWrap',function(){
  setTimeout(function(){
    $(document).find('.size-quick-drawer-wrap').removeClass('active');
    $(document).find('.size-quick-drawer').html('');
  },500)
  $('.size-quick-drawer').css('transform','translateY(100%)');
  $(document).find('.drawerOpenerWrap').removeClass('active');
  $(document).find('.my-outfit-home').removeClass("qwick-add-active");
});

$(document).on('mouseup','.size-quick-drawer-wrap',function(e) {
  var container = $('.size-quick-drawer');
  if (!container.is(e.target) && container.has(e.target).length === 0){
    $('.drawercloseWrap').click();
  }
});

$(document).on('click','.grid-size-values',function(){
  var self = $(this);
  $(this).addClass('active');
  $(this).find('.grid-collectswatch').hide();
  if($(document).find('.size-quick-drawer-wrap.active').length){
    $(this).find('.addToBagS').hide();
    $(this).find('.addToBagT').text('adding');
  }
  $(this).find('.spin-svg').show();
  var dataId =	$(this).data('id');
  console.log(dataId);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data : { id: dataId, quantity: 1 },
    dataType: 'json',
    success: function() {
      self.find('.spin-svg').hide();
      self.find('.check-svg').show();
      if($(document).find('.size-quick-drawer-wrap.active').length){
        self.find('.addToBagT').text('Added');
      }
      setTimeout(function(){
        self.find('.check-svg').hide();
        self.find('.grid-collectswatch').show();
        if($(document).find('.size-quick-drawer-wrap.active').length){
          self.find('.addToBagS').show();
          self.find('.addToBagT').text('add to bag');
        }
        self.removeClass('active');
      },1000)   
      $.getJSON('/cart.js', function(cart) {
        var item_count = cart.item_count;
        var item_total_price = cart.total_price / 100;
        var $cartItems = $('.mini-products-list');            
        $cartItems.empty()
        $('.site-header__cart-count').text(item_count);
        $('.subtotal .price').text('$'+item_total_price);
        if(item_count > 0) {
          $('#topCartContent .empty-page-content').removeClass('display').addClass('nodisplay');
          $('#topCartContent .cart_content').removeClass('nodisplay').addClass('display');
          for(var i = 0; i <= cart['items'].length; i++){
            var item = cart['items'][i];
            if (typeof item != 'undefined') {
              var product_title = item.title;
              var quantity = item.quantity;
              var line_price = item.line_price / 100;
              var url = item.url;
              var image_url = item.image;
              var item_id = item.id;
              var var_id = item.variant_id;
              var itemKey = item.key;
              $('.mini-products-list').append('<li class="item"><a class="product-image left" title="'+product_title+'" href="'+url+'"><div class="inner-wrapper" style="opacity: 1;"><img alt="'+product_title+'" src="'+image_url+'"></div></a><div data-sku="'+item.sku+'" class="product-details left"><p class="product-name"><a href="'+url+'">'+product_title+'</a></p><table cellpadding="0"><tbody><tr><th>Price</th><td><span class="price money">$'+ line_price.toFixed(2) +'</span></td></tr></tbody></table><ul class="item-options"><li><span class="label">Quantity:</span><span class="value color-value ">'+quantity+'</span></li></ul><div class="product-controls"><span data-id="'+var_id+'" data-key="'+itemKey+'" class="btn-remove cart_remove" title="Remove">Remove</span></div></div></li>');       
            }
          }
          $('#topCartContent').addClass('visible');
          $('.cart_overlay').show();
//           setTimeout(function(){
//             $('#topCartContent').removeClass('visible');
//             $('.cart_overlay').hide();
//           }, 5000);
        }
      });   
      return false;    
    },
      error: function() {

        if($(document).find('.size-quick-drawer-wrap.active').length){
        self.find('.spin-svg').hide();
        self.find('.grid-collectswatch').show()  
        self.find('.addToBagS').show();
        self.find('.addToBagT').text('add to bag');
        alert('Something went wrong. Please try again later !');
        }else{
          self.find('.spin-svg').hide(); 
          self.find('.grid-collectswatch').show();
          alert('Something went wrong. Please try again later !'); 
        }
     } 
  }); 
});  


$(document).on('mousedown','.swatch-custom-image',function(){
  var productUrl = $(this).attr('swatch-url');
  var productHandle = productUrl.replace('https://myoutfitonline.com/products/','');
  var thisElement = $(this).parents('[swatch-generated]');
  if (window.matchMedia('(max-width: 1024px)').matches) {
   thisElement.find('.drawerOpenerWrap').attr('value',productHandle);
  }else{
    thisElement.find('.collection_grid_sizewrap').html('<span class="loading-size" style="margin: 0 auto;"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25px" height="25px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="#000" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle><!-- [ldio] generated by https://loading.io/ --></svg></span>');
    $.ajax({
      type: 'GET',
      url: productUrl,
      dataType : "html",
      success: function(result) {
       var findSwatch = $(result).find('#itg-size-quick-modal').html();
       thisElement.find('.size-quick-modal-wrap').empty().html(findSwatch); 
       var findSwatch_1 = $(result).find('.product-main-form').find('.size-quick-modal-wrap').html();
       thisElement.find('.size-quick-modal-wrap').empty().html(findSwatch_1); 
      },
      error: function(status) {
        console.warn('ERROR', status);
      }
    });
  }
});

$(document).on('click','.mobile-slide-arrow-prev-arrow',function(){
  var currentSlidIndex = $('[data-armada-selector="product-thumbnail-slider"]').find('[data-slide-active]').attr('slide-num');
  currentSlidIndex = parseInt(currentSlidIndex) - 1
  console.log(currentSlidIndex);
  $(document).find('[data-slider-index="'+currentSlidIndex+'"]').trigger('click');
})
$(document).on('click','.mobile-slide-arrow-next-arrow',function(){
  var currentSlidIndex = $('[data-armada-selector="product-thumbnail-slider"]').find('[data-slide-active]').attr('slide-num');
   currentSlidIndex = parseInt(currentSlidIndex) + 1
  console.log(currentSlidIndex);
  $(document).find('[data-slider-index="'+currentSlidIndex+'"]').trigger('click');
})


$(document).on('click', '.mini_cart #checkout', function() {
    $.ajax({
      url: '/cart',
      dataType: 'html',
      success:function(data){
       $(data).find('[name="checkout"]').click();
      }
    });
});
